import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../../components/BootstrapCompo";
import { GlobalContext, handleError } from "../../context/Provider";
import henceforthApi from "../../utils/henceforthApi";

const AddDocumentType = () => {
    const { loading, setLoading, authState } = useContext(GlobalContext);
    const navigate = useNavigate();

    const [form, setForm] = useState({
        resource: "SELLER",
        name: "",
        description: "",
        status: "ACTIVE",
        sides_required: "BOTH"
    });

    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
        if (errors[name]) setErrors({ ...errors, [name]: "" });
    };

    const validate = () => {
        const newErrors: { [key: string]: string } = {};
        if (!form.name.trim()) newErrors.name = "Name is required";
        if (!form.resource) newErrors.resource = "Resource is required";
        return newErrors;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        try {
            await henceforthApi.DocumentType.add(form);
            navigate("/document-types/1");
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="breadcrum-box">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="fw-semibold">Add Document Type</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/document-types/1">Document Types</Link></li>
                                    <li className="breadcrumb-item active fw-bold">Add</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>

            <div className='page-spacing'>
                <section className='product-detail'>
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-sm-10 col-md-6 col-lg-5 col-xl-4 col-xxl-3">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>Add Document Type</h5>
                                    </div>
                                    <div className="common-card-content">
                                        <form onSubmit={handleSubmit}>
                                            {/* Resource */}
                                            <div className="form-fields-box mb-3">
                                                <label className="mb-1 fw-bold">Resource</label>
                                                <select
                                                    name="resource"
                                                    className="form-select rounded-0"
                                                    value={form.resource}
                                                    onChange={handleChange}
                                                >
                                                    <option value="SELLER">SELLER</option>
                                                    {/* Add more options as needed */}
                                                </select>
                                                {errors.resource && <div className="invalid-feedback d-block">{errors.resource}</div>}
                                            </div>

                                            {/* Name */}
                                            <div className="form-fields-box mb-3">
                                                <label className="mb-1 fw-bold">Name</label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className={`form-control rounded-0 ${errors.name ? 'is-invalid' : ''}`}
                                                    placeholder="Enter document type name"
                                                    value={form.name}
                                                    onChange={handleChange}
                                                    maxLength={55}
                                                />
                                                {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                                            </div>

                                            {/* Description */}
                                            <div className="form-fields-box mb-3">
                                                <label className="mb-1 fw-bold">Description</label>
                                                <textarea
                                                    name="description"
                                                    className="form-control rounded-0"
                                                    rows={3}
                                                    placeholder="Optional description"
                                                    value={form.description || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            {/* Status */}
                                            <div className="form-fields-box mb-3">
                                                <label className="mb-1 fw-bold">Status</label>
                                                <select
                                                    name="status"
                                                    className="form-select rounded-0"
                                                    value={form.status}
                                                    onChange={handleChange}
                                                >
                                                    <option value="ACTIVE">Active</option>
                                                    <option value="INACTIVE">Inactive</option>
                                                </select>
                                            </div>

                                            {/* Sides Required */}
                                            {/* <div className="form-fields-box mb-4">
                                                <label className="mb-1 fw-bold">Sides Required</label>
                                                <select
                                                    name="sides_required"
                                                    className="form-select rounded-0"
                                                    value={form.sides_required}
                                                    onChange={handleChange}
                                                >
                                                    <option value="FRONT">Front</option>
                                                    <option value="BACK">Back</option>
                                                    <option value="BOTH">Both</option>
                                                </select>
                                            </div> */}

                                            <div className="button-box">
                                                <button type="submit" className="btn btn-theme w-100" disabled={loading}>
                                                    {loading ? <Spinner /> : "Add Document Type"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AddDocumentType;